import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".7",
      "fill-rule": "evenodd",
      d: "M12 4a5 5 0 0 1 2.429 9.372C17.098 14.224 19 16.488 19 19.5a.5.5 0 1 1-1 0c0-3.314-2.687-5.5-6-5.5s-6 2.186-6 5.5a.5.5 0 1 1-1 0c0-3.012 1.902-5.276 4.571-6.13A5 5 0 0 1 12 4M8 9a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
      "clip-rule": "evenodd",
      style: {"mix-blend-mode":"normal"}
    }, null, -1)
  ])))
}
export default { render: render }